import { render, staticRenderFns } from "./IconCrown.vue?vue&type=template&id=0aa89d74&"
import script from "./IconCrown.vue?vue&type=script&lang=js&"
export * from "./IconCrown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports